import { injectIntl as inject } from 'react-intl';

export const injectIntl = (options?: any) => (target: any) => {
    return inject(target, options) as any;
};
